import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { CountBadge } from './CountBadge';

/**
 * Icon-only toggle for revealing rows hidden by default (employer-paid,
 * ineligible, etc.). Mirrors FilterButton's three visual states:
 *   1. Off, nothing hidden  → grey icon button
 *   2. Off, hidden rows exist → grey + CountBadge overlay
 *   3. On (showing hidden)    → full theme fill
 */
const THEME_CONFIG = {
  admin: {
    base: 'icon-button-admin',
    active: 'bg-red-500 text-white hover:bg-red-600 hover:text-white',
  },
  employee: {
    base: 'icon-button',
    active: 'bg-blue-800 text-white hover:bg-blue-900 hover:text-white',
  },
};

export const ShowHiddenToggleButton = ({
  theme = 'admin',
  isActive = false,
  hiddenCount = 0,
  onClick,
  titleOff = 'Show hidden rows',
  titleOn = 'Hide hidden rows',
  className = '',
}) => {
  const config = THEME_CONFIG[theme] || THEME_CONFIG.admin;
  const title = isActive ? titleOn : titleOff;
  const activeClasses = isActive ? config.active : '';

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${config.base} relative ${activeClasses} ${className}`.trim()}
      title={title}
      aria-label={title}
      aria-pressed={isActive}
    >
      {isActive ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
      {!isActive && hiddenCount > 0 && (
        <CountBadge count={hiddenCount} theme={theme} overlay />
      )}
    </button>
  );
};

export default ShowHiddenToggleButton;
